import React from "react";
import { PuffLoader } from "react-spinners";

const FormLoader = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <PuffLoader color={"#83442B"} size={60} />
    </div>
  );
};

export default FormLoader;
